import { AccountStatus, CardTypesEnum, Enrollment } from '@common-fe/common-fe';

import useGetAccountsWithVerificationStatusQuery from './useGetAccountsWithVerificationStatus.query';

export const getAppropriateEnrollment = (enrollment: Enrollment) => enrollment?.accountStatus === AccountStatus.PENDING
  && enrollment?.accountType === CardTypesEnum.EXTERNAL;

const useGetDataForBannerPlaidVerification = (employeeId?: string) => {
  const { formattedAccount, refetch } = useGetAccountsWithVerificationStatusQuery(
    employeeId,
    CardTypesEnum.EXTERNAL,
    AccountStatus.PENDING,
  );

  return {
    formattedAccount,
    refetch,
  };
};

export default useGetDataForBannerPlaidVerification;
